import styled from 'styled-components';

import { Breakpoint, Color } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { hexToRgba } from '../../utils';
import { BoxTitle } from '../boxTitle/boxTitle.component';
import { Icon } from '../icon/icon.component';
import { Image } from '../image/image.component';

export const Container: StyledComponent<'div'> = styled.div`
  width: 100%;

  .masonry-grid {
    display: flex;
    flex-wrap: wrap;
  }
`;

export const StyledArtworkMosaicItem: StyledComponent<'div'> = styled.div`
  width: 25%;
  padding: 0 20px 80px;

  @media ${Breakpoint.Tablet} {
    width: 33.3%;
    padding: 0 16px 80px;
  }

  @media ${Breakpoint.Mobile} {
    padding: 0 10px 80px;
  }

  @media ${Breakpoint.SmallMobile} {
    width: 50%;
  }
`;

export const ImageElement: StyledComponent<typeof Image> = styled(Image)`
  width: 100%;
  height: auto;
`;

export const StyledBoxTitle: StyledComponent<typeof BoxTitle> = styled(BoxTitle)`
  margin-top: 16px;
`;

export const LikeIconContainer: StyledComponent<'button'> = styled.button`
  position: absolute;
  top: 8px;
  left: 28px;
  width: 32px;
  height: 32px;
  background-color: ${hexToRgba(Color.Black, 0.25)};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  @media ${Breakpoint.Tablet} {
    left: 24px;
  }

  @media ${Breakpoint.Mobile} {
    left: 18px;
  }
`;

export const StyledIcon: StyledComponent<typeof Icon> = styled(Icon)`
  transition: 0.3s;
`;
